import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { useLastListenVisit } from "../../listen/listen-visit";

export function useNewSurveyResults(): ReturnType<typeof useSupabaseLoader<boolean>> {
  const since = useLastListenVisit();

  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      let query = supabase
        .from("survey_response_with_identifier_questions")
        .select("id")
        .eq("account_id", account_id);
      if (since) query = query.gt("created_at", since);

      const { data, error } = await query.limit(1);
      if (error) throw error;

      return data.length > 0;
    },
    [since],
  );
}
